import { useEffect } from 'react';
import useFeatureToggles from 'hooks/user/useFeatureToggles';
import useRequestContext from 'hooks/user/useRequestContext';
import useSegmentation from 'hooks/user/useSegmentation';
import { cookieConsentId } from './shared/constants';
import { createScript } from './shared/helpers';

export default function CookieConsentLoader() {
    const { culture } = useSegmentation();
    const { isClubMatasApp, posRequest } = useRequestContext();
    const { acceptCookies, isCookieInformationEnabled, disable3rdParty } = useFeatureToggles();
    const { isPosRequest } = posRequest || {};
    const languageCode = culture.split('-')[0].toUpperCase();

    /*
     * Feature toggles:
     * - disable3rdParty (in url: disable3rdParty): If true, do not load third party scripts.
     * - isCookieInformationEnabled (in url: cookieInformation): If false, do not load the Cookie Information script.
     * - acceptCookies (in url: acceptCookies): If true, simulate all cookie have been accepted and do not load the Cookie Information script.
     * */

    useEffect(() => {
        const cookieConsentLoaded = document.getElementById(cookieConsentId);

        if (
            cookieConsentLoaded ||
            isClubMatasApp ||
            isPosRequest ||
            disable3rdParty ||
            !isCookieInformationEnabled ||
            acceptCookies
        ) {
            return;
        }

        document.body.appendChild(createScript(languageCode));
    }, [languageCode, isClubMatasApp, isPosRequest]);

    return null;
}
